'use client'

import { useEffect } from 'react'

import { isClubEligible } from '@/helpers/club'
import { useCustomer } from '@/store/customerStore'
import { useMetaObjects } from '@/store/metaObjectStore'

/**
 * Client-only club-visibility gate for navigation. Fails closed: the club menu
 * entry stays hidden until we positively know the customer is eligible —
 * customer store hydrated AND fresh clubConfig loaded in the browser. Avoids the
 * brittle server-prop clubConfig cache split; access control itself stays on the
 * dynamic server page gate.
 */
export const useCanSeeClub = (): boolean => {
  const isLoaded = useCustomer(s => s.isLoaded)
  const customer = useCustomer(s => s.customer)
  const clubConfig = useMetaObjects(s => s.clubConfig)
  const getClubConfig = useMetaObjects(s => s.getClubConfig)

  useEffect(() => {
    // Idempotent: returns the cached config once loaded.
    void getClubConfig()
  }, [getClubConfig])

  if (!isLoaded || clubConfig == null) return false
  return isClubEligible(customer, clubConfig)
}
